import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TrackableEventAction, TrackingEventSource } from '../../../app/package/base/service/tracking/tracking-service';
import { type GameDetails, TileType } from '../../base/package/api/package/gaming/gaming-domain';
import { I18n } from '../../base/package/services/package/i18n/i18n.de';
import style from './ui-free-spin-available.css?inline';
import '../incentive/game-tile-deck/game-tile-deck';
import '../ui-icons/ui-chevron-arrow-icon';

const CName = 'ui-free-spin-available';

@customElement(CName)
export class UIFreeSpinAvailable extends LitElement {
  static readonly styles = unsafeCSS(style);

  @property({ type: Array }) games: GameDetails[] = [];

  connectedCallback(): void {
    super.connectedCallback();
    window.$app.track.customEvent({
      event: TrackingEventSource.FS_WIDGET,
      eventAction: TrackableEventAction.SHOWN,
    });
  }

  render() {
    return html`
      <button
        class="free-spin-widget"
        style=${`--_bg-image: url(${window.staticAssets.gamification?.incentiveBackground})`}
        aria-label=${window.$app.$t.get(I18n.rewards.freeSpinWidgetText)}
      >
        <incentive-game-tile-deck
          class="free-spin-widget__deck"
          style="--deck-tile-count: ${this.games.length}"
          .games=${this.games}
          .tileType=${TileType.P5}
          variant="fanned"
        ></incentive-game-tile-deck>
        <span class="free-spin-widget__text">
          ${window.$app.$t.get(I18n.rewards.freeSpinWidgetText)}
        </span>
        <ui-chevron-arrow-icon class="arrow-icon"></ui-chevron-arrow-icon>
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIFreeSpinAvailable;
  }
}
